<template>
  <div>
    <h1 v-html="modelValue.Content.StepTwo.LabelSectionTitle" />

    <section>
      <article class="flow-group">
        <div class="control">
          <div class="row">
            <div class="columns small-6">
              <label
                class="h3"
                for="FirstName"
                v-html="modelValue.Content.StepTwo.LabelFirstname"
              />
              <Field
                v-model="studyInsuranceSubmitTemplate.Firstname"
                :rules="'required'"
                type="text"
                name="FirstName"
                :data-vv-as="modelValue.Content.StepTwo.FieldNameFirstname"
              />
              <ValidationError
                name="FirstName"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              />
            </div>
            <div class="columns small-6">
              <label class="h3" for="Lastname" v-html="modelValue.Content.StepTwo.LabelLastname" />
              <Field
                v-model="studyInsuranceSubmitTemplate.Lastname"
                :rules="'required'"
                type="text"
                name="LastName"
                :data-vv-as="modelValue.Content.StepTwo.FieldNameLastname"
              />
              <ValidationError
                name="LastName"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              />
            </div>
          </div>
        </div>
        <div class="control">
          <div class="row">
            <div class="columns small-6">
              <label class="h3" for="phone" v-html="modelValue.Content.StepTwo.LabelPhoneNumber" />
              <Field
                v-model="studyInsuranceSubmitTemplate.PhoneNumber"
                :rules="'required|numeric|min:8|max:8'"
                type="text"
                name="phone"
                :data-vv-as="modelValue.Content.StepTwo.FieldNamePhoneNumber"
              />
              <ValidationError
                name="phone"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              />
            </div>
            <div class="columns small-6">
              <label class="h3" for="email" v-html="modelValue.Content.StepTwo.LabelEmail" />
              <Field
                v-model="studyInsuranceSubmitTemplate.Email"
                :rules="'required|email'"
                type="text"
                name="email"
                :data-vv-as="modelValue.Content.StepTwo.FieldNameEmail"
              />
              <ValidationError
                name="email"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              />
            </div>
          </div>
        </div>
        <div class="control">
          <h3 v-html="modelValue.Content.StepTwo.LabelAddress" />
          <Field
            name="quickquote-validation-address"
            :rules="'required'"
            :label="modelValue.Content.StepTwo.FieldNameAddress"
            :modelValue="localModel.address"
          >
            <address-search
              v-model="localModel.address"
              class="v-select-search-icon"
              name="quickquote-validation-address"
              placeholder="Indtast vejnavn"
              :zip-code="studyInsuranceSubmitTemplate.Zip"
            />
          </Field>
          <ValidationError name="quickquote-validation-address" />
        </div>
        <div class="control">
          <h3 v-html="modelValue.Content.StepTwo.LabelZipAndCity" />
          <div class="row input-section">
            <div class="small-4 columns cpr-number-birthday">
              <Field v-model="studyInsuranceSubmitTemplate.Zip" name="zip" type="text" disabled />
            </div>
            <div class="small-8 columns">
              <Field
                id="PostalCode"
                v-model="studyInsuranceSubmitTemplate.City"
                :rules="'required'"
                type="text"
                disabled
                name="PostalCode"
                :data-vv-as="modelValue.Content.StepTwo.FieldNameAddress"
              />
            </div>
          </div>
        </div>
        <div class="control">
          <h3 v-html="modelValue.Content.StepTwo.LabelAndTooltipCurrentEducationalInstitution" />
          <Field
            v-model="studyInsuranceSubmitTemplate.CurrentEducationalInstitution"
            :rules="'required'"
            type="text"
            name="CurrentEducationalInstitution"
            :data-vv-as="modelValue.Content.StepTwo.FieldNameCurrentEducationalInstitution"
          />
          <ValidationError
            name="CurrentEducationalInstitution"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
        </div>
        <div class="control">
          <h3 v-html="modelValue.Content.StepTwo.LabelAndTooltipExpectedFinishingDate" />
          <Field
            :label="modelValue.Content.StepTwo.FieldNameExpectedFinishingDate"
            name="ExpectedFinishingDate"
            :rules="{ required: true }"
            :model-value="localModel.expectedFinishingDate"
          >
            <date-picker
              id="ExpectedFinishingDate"
              v-model="localModel.expectedFinishingDate"
              name="ExpectedFinishingDate"
              :date="localModel.expectedFinishingDate"
              :min-date="localModel.currentDate"
              class="datepicker"
              :year-range="[new Date().getFullYear(), new Date().getFullYear() + 10]"
              @update:model-value="
                localModel.expectedFinishingDate = $event;
                dateChanged($event);
              "
            />
          </Field>
          <ValidationError
            name="ExpectedFinishingDate"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import Utility from '@/common/UtilityFunctions.js';
import StudyMixin from './StudyMixin.vue';
import DatePicker from '@/components/UI/Pickadate.vue';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'PersonalInfoStudy',
  components: {
    AddressSearch,
    ValidationError,
    DatePicker
  },
  emits: ['update:modelValue'],
  mixins: [StudyMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    },
    localModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    studyInsuranceSubmitTemplate: {
      get() {
        if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Data')) {
          return this.modelValue.Data.StudyInsuranceSubmitTemplate;
        }
        return {};
      },
      set(val) {
        const tmp = { ...this.modelValue };
        tmp.Data.StudyInsuranceSubmitTemplate = val;
        this.$emit('update:modelValue', tmp);
      }
    }
  },
  watch: {
    'localModel.address.tekst': function (val) {
      this.studyInsuranceSubmitTemplate.Address = val;
      this.studyInsuranceSubmitTemplate.Zip = this.localModel.address.adresse.postnr;
      this.studyInsuranceSubmitTemplate.City = this.localModel.address.adresse.postnrnavn;
    }
  },
  mounted() {
    Utility.pushToTagManager({
      event: 'track-ga-vp',
      virtualPath: '/virtual/studie-prisberegner-02-personlige-oplysninger',
      virtualTitle: 'Virtuel - Beregn pris - Studie - personlige-oplysninger'
    });
  },
  methods: {
    dateChanged(param) {
      this.studyInsuranceSubmitTemplate.ExpectedFinishingDate = moment(param).format();
    }
  },
  template: '#templateForPersonalInfoStudy'
};
</script>
